import React from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import UserCalendar from "./UserCalendar";
import Header from "../components/Header";

function UserCalendarWrapper({ onLogout }) {
  const { username } = useParams();

  const navigate = useNavigate();
  const handleConfirmLogout = () => {
    onLogout();
    navigate("/");
  };

  const dummyUser = {
    username: username,
  };

  return (
    <>
      <Header onLogout={handleConfirmLogout}/>
      <UserCalendar user={dummyUser} />
    </>
  );
}

export default UserCalendarWrapper;
